import * as React from 'react';
import { RoundedButton } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';
import { loadDitto, vtoEvent } from '../../utils.js';
import { useVto } from '../../../context/VtoProvider.js';

const DittoPreview = ({ sku , dittoId , onError , onDelete , onRetake  })=>{
    const { config  } = useVto();
    const { accessKey , apiUrl , sdkUrl , isEnabled , getSignature , partnerId  } = config;
    React.useEffect(()=>{
        if (!isEnabled || !dittoId) {
            return;
        }
        let instance;
        Promise.all([
            loadDitto(sdkUrl),
            getSignature(dittoId)
        ]).then(([ditto, signature])=>{
            let isStatusSuccess = false;
            instance = new ditto.Overlay({
                accessKey,
                domSelector: '.ditto-preview__target',
                font: 'nunitosans',
                glassesId: sku,
                overlaySignature: signature,
                partnerId,
                scanId: dittoId,
                tryOnServer: apiUrl
            }, {
                success: ()=>{
                    isStatusSuccess = true;
                },
                failure: ()=>{
                    if (!isStatusSuccess) {
                        vtoEvent('vto.creation.error', {
                            sku
                        });
                        onRetake();
                    }
                }
            });
        }).catch(onError);
        return ()=>{
            instance && instance.destroy();
        };
    }, [
        dittoId,
        sku
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "ditto-preview",
        "data-t": "ditto-preview"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "ditto-preview__target"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "ditto-preview__actions"
    }, /*#__PURE__*/ React.createElement(RoundedButton, {
        variant: "solid",
        size: "small",
        className: "ditto-preview__action",
        onClick: ()=>{
            vtoEvent('vto.tryon.retake', {
                sku
            });
            onRetake();
        },
        "data-t": "ditto-preview-retake"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "pencil"
    })), /*#__PURE__*/ React.createElement(RoundedButton, {
        variant: "solid",
        size: "small",
        className: "ditto-preview__action",
        onClick: ()=>{
            vtoEvent('vto.tryon.delete', {
                sku
            });
            onDelete();
        },
        "data-t": "ditto-preview-delete"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "trash"
    }))));
};

export { DittoPreview };
//# sourceMappingURL=DittoPreview.js.map
